import { Autocomplete, Button, Grid, TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext, useState } from "react";
//import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";

import { CloseSharp, DeleteSharp, SaveSharp } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "../../axiosInstances";
import { ShoppingCartContext } from "../Context/ShoppingCartContext";
const validationSchema = Yup.object().shape({
  Name: Yup.string().required("Name is required!!!")
});
export default function SalesRoutesModel(props) {
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const { globalToken, globalUser } = useContext(ShoppingCartContext);
  const [id, setId] = useState(props.data.Id);
  const [name, setName] = useState(props.data?.Name);
  const [deliveryPerson, setDeliveryPerson] = useState(
    props.data?.DeliveryPerson
  );
  const [salesRepresentative, setSalesRepresentative] = useState(
    props.data?.SalesRepresentative
  );

  const [supervisor, setSupervisor] = useState(props.data?.Supervisor ? props.data?.Supervisor : 0);
  const [pathDetail, setPathDetail] = useState(props.data?.PathDetail);
  const [remark, setRemark] = useState(props.data?.Remark);
  const [employeeList, setEmployeeList] = useState(props.Employees);

  const handleSubmit = () => {
    if (
      window.confirm("Are you sure you want to save?")
    ) {
      try {
        var fd = new FormData();
        fd.append("Id", id);
        fd.append("Name", name);
        fd.append("DeliveryPerson", deliveryPerson);
        fd.append("SalesRepresentative", salesRepresentative);
        fd.append("Supervisor", supervisor);
        fd.append("RoutePath", pathDetail);
        fd.append("Parent", globalUser.Parent);
        fd.append("Remark", remark);
        alert(supervisor)
        axios.post("/SalesRoutes", fd, {
          headers: { "Content-Type": "application/json", token: globalToken },
        });
      } catch (err) {
      } finally {
        props.setParentUpdate(!props.ParentUpdate);
        setOpen(false);
      }
    }

  };
  const handleDelete = () => {
    try {
      axios.delete("/SalesRoutes?Id=" + id, {
        headers: {
          token: globalToken,
        },
      });
    } catch (err) {
    } finally {
      setOpen(false);
    }
  };


  return (
    <div width="500">
      <label onClick={() => setOpen(true)}>{props.icon}</label>
      <Formik
        initialValues={props.data}
        onSubmit={
          handleSubmit
        }
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
          <Dialog
            maxWidth="md"
            /*      PaperProps={{
               sx: {
                 height: '80vh',   // 80% of viewport height
                 maxHeight: '90vh',
               },
             }} */
            open={open}
            onClose={() => {
              setOpen(false);
            }}
            aria-labelledby="responsive-dialog-title"
          >
            {/* 
        <DialogTitle id="responsive-dialog-title"> </DialogTitle> */}

            <DialogTitle
              color={theme.palette.primary.contrastText}
              bgcolor={theme.palette.primary.main}
            >
              {props.Title}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>


                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label={t("Name")}
                      name="Name"
                      defaultValue={values.Name}
                      onChange={(e) => {
                        values.Name = e.target.value;
                        setName(e.target.value);
                      }}
                      onBlur={handleBlur("Name")}
                      sx={{ width: "95%", marginBottom: 2 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors.Name && (
                      <span style={{ color: "red" }}> {errors.Name}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      //disabled={((status === "Received") || (globalUser.Name===transferedTo)) ? true : false}
                      disablePortal
                      selectOnFocus
                      autoHighlight
                      contentEditable={false}
                      value={
                        employeeList.filter(
                          (cat) =>
                            parseInt(cat.Id) === parseInt(salesRepresentative)
                        ).length > 0
                          ? employeeList.filter(
                            (cat) =>
                              parseInt(cat.Id) === parseInt(deliveryPerson)
                          )[0]?.Name
                          : ""
                      }
                      id="deliveryPerson"
                      onSelect={(e) => {
                        setDeliveryPerson(
                          employeeList.filter((cat) => cat.Name === e.target.value)
                            .length > 0
                            ? employeeList.filter(
                              (cat) => cat.Name === e.target.value
                            )[0].Id
                            : 0
                        );
                      }}
                      options={
                        !(employeeList === undefined) &&
                          !(employeeList === null) &&
                          employeeList.length > 0
                          ? employeeList.map((item) => {
                            return item.Name;
                          })
                          : [""]
                      }
                      sx={{
                        width: "100%",
                        marginBottom: 2,
                        borderRadius: "25%",
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Delivery Person"
                          variant="standard"
                        //error={!fromAirport ? true : false}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      //disabled={((status === "Received") || (globalUser.Name===transferedTo)) ? true : false}
                      disablePortal
                      selectOnFocus
                      autoHighlight
                      contentEditable={false}
                      value={
                        employeeList.filter(
                          (cat) =>
                            parseInt(cat.Id) === parseInt(salesRepresentative)
                        ).length > 0
                          ? employeeList.filter(
                            (cat) =>
                              parseInt(cat.Id) === parseInt(salesRepresentative)
                          )[0].Name
                          : ""
                      }
                      id="salesRepresentative"
                      onSelect={(e) => {
                        setSalesRepresentative(
                          employeeList.filter((cat) => cat.Name === e.target.value)
                            .length > 0
                            ? employeeList.filter(
                              (cat) => cat.Name === e.target.value
                            )[0].Id
                            : 0
                        );
                      }}
                      options={
                        !(employeeList === undefined) &&
                          !(employeeList === null) &&
                          employeeList.length > 0
                          ? employeeList.map((item) => {
                            return item.Name;
                          })
                          : [""]
                      }
                      sx={{
                        width: "100%",
                        marginBottom: 2,
                        borderRadius: "25%",
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="sales Representative"
                          variant="standard"
                        //error={!fromAirport ? true : false}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      //disabled={((status === "Received") || (globalUser.Name===transferedTo)) ? true : false}
                      disablePortal
                      selectOnFocus
                      autoHighlight
                      contentEditable={false}
                      value={
                        employeeList.filter(
                          (cat) => parseInt(cat.Id) === parseInt(supervisor)
                        ).length > 0
                          ? employeeList.filter(
                            (cat) => parseInt(cat.Id) === parseInt(supervisor)
                          )[0].Name
                          : ""
                      }
                      id="supervisor"
                      onSelect={(e) => {
                        setSupervisor(() =>
                        (employeeList.filter((cat) => cat.Name === e.target.value)
                          .length > 0
                          ? employeeList.filter(
                            (cat) => cat.Name === e.target.value
                          )[0].Id
                          : 0)
                        );
                      }}
                      onChange={(event, newValue, reason) => {
                        // Commit immediately if selected with mouse or option chosen
                        if (reason === "selectOption") {
                          setSupervisor(newValue);
                        }
                      }}
                      options={
                        !(employeeList === undefined) &&
                          !(employeeList === null) &&
                          employeeList.length > 0
                          ? employeeList.map((item) => {
                            return item.Name;
                          })
                          : [""]
                      }
                      sx={{
                        width: "100%",
                        marginBottom: 2,
                        borderRadius: "25%",
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="supervisor"
                          variant="standard"
                        //error={!fromAirport ? true : false}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label="Remark"
                      defaultValue={remark}
                      multiline
                      maxRows={4}
                      sx={{ width: "95%", marginBottom: 2 }}
                      onChange={(e) => {
                        setRemark(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
                <hr></hr>
              </DialogContentText>
            </DialogContent>
            <DialogActions
              style={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                flexWrap: 'wrap',
              }}
            >
              <Button variant="standard" endIcon={<SaveSharp />} autoFocus onClick={handleSubmit}>
                Save
              </Button> |
              <Button variant="standard" endIcon={<DeleteSharp />} autoFocus onClick={handleDelete}>
                Delete
              </Button>|
              <Button variant="standard" endIcon={<CloseSharp />} onClick={() => setOpen(false)} autoFocus>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Formik>
    </div>
  );
}
